<template>
    <div class="wrapper">
      <div class="center-wrapper nav">
          <img style="width: auto;height: 60px;" src="../assets/img/logo.png" alt="珠宝检测网">
          <el-menu
              :default-active="$route.fullPath" 
              mode="horizontal" 
              text-color="#000"
              active-text-color="#2093CA"
              @select="handleSelect">
              <el-menu-item index="/">证书查询</el-menu-item>
              <!-- <el-menu-item index="/utilities">实用工具</el-menu-item> -->
              <el-submenu index="/utilities" popper-class="submenu-header">
                <span slot="title" class="submenu-title">实用工具</span>
                <el-menu-item index="/utilities?utilType=1">今日金价</el-menu-item>
                <el-menu-item index="/utilities?utilType=2">钻石计算器</el-menu-item>
              </el-submenu>
              <el-menu-item index="/Expert">业内行家</el-menu-item>
              <el-menu-item index="/Trade">行业讯息</el-menu-item>
              <el-submenu index="/jewelryEncyc" popper-class="submenu-header">
                <span slot="title" class="submenu-title">珠宝百科</span>
                <template v-if="leftList">
                <el-menu-item :index="`/jewelryEncyc?jewelryEncycType=${item.id}`" v-for="(item, index) of leftList" :key="index">{{item.title}}</el-menu-item>
                </template>
              </el-submenu>
              <el-menu-item index="/aboutUs">关于我们</el-menu-item>
          </el-menu>
      </div>
    </div>
</template>
<script>
  export default {
  name: 'Header',
  props: {
    active: String,
  },
  computed: {
    leftList: function(){
        return this.$store.state?.jewelryEncycData?.data?.left_list || []
    }
  },
  data(){
    return {
    }
  },
  created(){},
  mounted(){},
  methods:{
    handleSelect(key, keyPath) {
      this.$router.push(key);
    },
   
  }
}
</script>
<style lang="scss" scoped>
 /* 最小宽度是1550px时 */
@media (max-width:1550px) {
  .wrapper {
    .el-menu-item{
        padding: 0px 15px !important;
      }
    ::v-deep .el-menu--horizontal>.el-submenu .el-submenu__title {
      padding: 0;
      height: 56px;
      line-height: 56px!important;
    }
  }
}
.el-menu--horizontal>.el-submenu .el-submenu__title {
  padding: 0;
}
.wrapper {
  margin: auto;
  position:sticky;
  position: -webkit-sticky;
  top:0;
  z-index:1000;
  .el-menu.el-menu--horizontal{
      border: none;
    }
    .el-menu--horizontal > .el-menu-item {
      border-bottom: none;
      text-decoration: none;
    }
    .el-menu , .el-menu-item:hover,.el-menu-item.is-active,.el-submenu__title.is-active,.el-submenu__title:hover{
      background: transparent;
    }
    .el-menu li:hover {
        border-bottom: 1px solid #2093ca!important;
        transform: scale(1.02);
    }
    .el-menu-item, .submenu-title {
      font-size: 20px;
      padding: 0px 22px;
    }
    .submenu-title {
      color: #000;
      padding-right: 5px;
    }
}
::v-deep .el-menu--horizontal>.el-submenu .el-submenu__title {
  height: 56px;
  line-height: 56px!important;
}
.submenu-header {
  .el-menu {
    .el-menu-item, .submenu-title {
      text-align: center;
      font-size: 20px;
      padding: 10px 22px;
      height: auto;
      color: #000;
      &:not(:last-child) {
        border-bottom: 1px solid rgb(238,238,238);
      }
    }
  }
}
.nav {
  display: flex;
  justify-content: space-between;
  padding: 14px 0;
}
 img {
    width: 231px;
    height: 59px;
  }
</style>
<style>
.submenu-header .el-menu {
  width: 167px;
  min-width: auto;
  border-radius: 0 0 10px 10px;
}
</style>